<template>
    <button
        class="NavToggle"
        :class="activeClass"
        @click="toggle"
    >
        <div>
            <span
                class="NavToggle__inner"
            />
        </div>
    </button>
</template>
<script>
import { toggleState } from '@mixins/toggleState.js'
import { toggleBodyClass } from '@mixins/toggleBodyClass.js'

export default {
    name: 'NavToggle',
    mixins: [toggleBodyClass, toggleState],
    methods: {
        toggle() {
            this.toggleBodyClass('nav-is-active');
            this.toggleBodyClass('flyout-is-active');
            this.toggleState();
        }
    },
    watch: {
        isActive() {
            this.$emit('toggle', this.isActive)
        }
    }
}
</script>
<style lang="scss">

.NavToggle {
    padding: getSpacing('spacer');
    border-left: 1px solid $border-color;

    div {
        position: relative;
        top: -2px;
        display: inline-block;
        width: 24px;
        height: 21px;
        perspective: 80px;
    }

    @include media-query(lap) {
        padding-right: 0;
        padding-top: getSpacing('medium');
        padding-bottom: getSpacing('medium');
    }

    @include media-query(reciteme-and-up) {
        display: none;
    }
}

.NavToggle__inner {
    position: absolute;
    width: 24px;
    height: 2px;
    border-radius: 12px;
    background-color: $action-color;
    top: 50%;
    transition: transform .15s cubic-bezier(.645,.045,.355,1),background-color 0s cubic-bezier(.645,.045,.355,1) .1s;

    .is-active & {
        transform: rotateY(180deg);
        background-color: transparent!important;
    }

    &:before, &:after {
        display: block;
        content: "";
        transition: transform 0s cubic-bezier(.645,.045,.355,1) .1s;
        position: absolute;
        width: 24px;
        height: 2px;
        border-radius: 12px;
        background-color: $action-color;
    }

    &:before {
        top: -7px;

        .is-active & {
            transform: translate3d(0,7px,0) rotate(45deg);
        }
    }

    &:after {
        bottom: -7px;

        .is-active & {
            transform: translate3d(0,-7px,0) rotate(-45deg);
        }
    }
}

</style>
